module.exports = __webpack_public_path__ + "static/media/Gjemme.5563dd62.m4a";